declare var d3: any;

import { Injectable } from '@angular/core';
import '../../assets/libs/d3.v3.min.js';

@Injectable()
export class BarchartService {


  constructor() { }

  buildFirstBarChart(data){
  	var colorScheme = ["#2185D0","#db2e2e","#7986CB","#A1887F","#90A4AE","#AED581","#9575CD","#FF8A65","#4DB6AC","#FFF176","#64B5F6","#00E676"];

    var margin = {top: 0, right: 18, bottom: 10, left: 40},
				width = 630 - margin.left - margin.right,
				height = 260 - margin.top - margin.bottom,
				height2 = height*0.75;

		var column_width = 46;

		var textfontsize = "12px";

		var w = window.innerWidth;
		if (w < 767){
		  margin = {top: 0, right: 20, bottom: 10, left: 40};
		  width = window.innerWidth - margin.left - margin.right - 25;
		  height = 220 - margin.top - margin.bottom,
			height2 = height*0.75
		  column_width = 22.5;
		  textfontsize = "9px";
		}

		var x = d3.scale.ordinal().rangeRoundBands([0, width], .1);
		var y = d3.scale.linear().rangeRound([height2, 0]);
		var color = d3.scale.ordinal().range(colorScheme);
		var xAxis = d3.svg.axis().scale(x).orient("bottom")
							.tickFormat(function(d) {
								//return (new Date(+d) + "").substring(3,6);
								return d;
							});

		var yAxis = d3.svg.axis().scale(y).orient("left")
							.tickFormat(function(d) {
								return d + "%";
							});

    d3.selectAll("#chart > *").remove();

		var svg = d3.select("#chart").append("svg")
		          .attr("id", "chartSVG")
							.attr("width", width + margin.left + margin.right)
							.attr("height", height + margin.top + margin.bottom)
							//.attr("style","background:#efefef;")

		var main = svg.append("g")
							.attr("height", height2)
							.attr("transform", "translate(" + margin.left + "," + (height*0.20) + ")");

		var active_link = "0";
		var legendClicked;
		var legendClassArray = [];
		var y_orig;
		var class_keep;
		var idx;
		var h_keep, y_keep, h_base, y_base, h_shift, y_new;

		color.domain(d3.keys(data[0]).filter(function(key) { return key !== "label"; }));

		data.forEach(function(d) {
			var mylabel = d.label;
			var y0 = 0;
			d.params = color.domain().map(function(name) {
			          return {
			            mylabel:mylabel,
			            name: name,
			            y0: y0,
			            y1: y0 += +d[name],
			            show: d[name]
			          }; });
			d.total = d.params[d.params.length - 1].y1;
		});

		x.domain(data.map(function(d) { return (d.label); }));
		y.domain([0, d3.max(data, function(d) { return d.total; })]);

		main.append("g")
							.attr("class", "x axis")
							.attr("transform", "translate(0," + height2 + ")")
							.style("stroke-width","0px")
							.attr("stroke","#2185D0")
							.attr("style","color:#2185D0; font-weight:100; font-style: normal;")
							.call(xAxis);

		main.append("g")
							.attr("class", "y axis")
							.style("stroke-width","0.1px")
							.attr("stroke","#2185D0")
							.attr("fill","0px")
							.call(yAxis)
							.append("text")
							.attr("style","color:#2185D0; font-weight:100; font-style: normal;")
							.attr("transform", "rotate(-90)")
							.attr("y", 6)
							.attr("dy", ".71em")
							.style("text-anchor", "end");

		var state = main.selectAll(".state")
							.data(data)
							.enter().append("g")
							.attr("class", "g")
							.attr("transform", function(d) { return "translate(" + "0" + ",0)"; });


		state.selectAll("rect")
							.data(function(d) {	return d.params; })
							.enter().append("rect")
							.attr("width", column_width)
							.attr("y", function(d) { return y(d.y1); })
							.attr("x",function(d) { return x(d.mylabel) })
							.attr("height", function(d) { if (d.show > 0) return y(d.y0) - y(d.y1); else return 0; })
							.attr("class", function(d) {
											var classLabel = d.name.replace(/\s/g, '');
											return "class" + classLabel;
							})
							.style("fill", function(d) { return color(d.name); })


		state.append("text")
		          .attr("y", function(d) { return y(d.params[0].y1) + (column_width-4)/2; })
	            .attr("x", function(d) { return x(d.params[0].mylabel) + column_width/2; } )
              .style("text-anchor", "middle")
	            .style("font-size", textfontsize)
	            .style("stroke", "white")
	            .style("stroke-width","0")
	            .style("fill", "white")
							.text(function(d) {return Math.floor(d.Solar) + '%';});

		state.selectAll("rect")
							.on("mouseover", function(d){
											var delta = d.y1 - d.y0;
											var xPos = parseFloat(d3.select(this).attr("x"));
											var yPos = parseFloat(d3.select(this).attr("y"));
											var height = parseFloat(d3.select(this).attr("height"))
											d3.select(this).attr("stroke","blue").attr("stroke-width",0.8);
											//	tip.show(d);
											/*	main.append("text")
														.attr("x",xPos)
														.attr("y",yPos +height/2)
														.attr("class","tooltip")
														.text(d.name +": "+ delta.toFixed(0));
											*/
							})
							.on("mouseout",function(){
											//tip.hide();
											/*main.select(".tooltip").remove();*/
											d3.select(this).attr("stroke","pink").attr("stroke-width",0.2);
							})

		var legend = svg.selectAll(".legend")
							.data(color.domain().slice().reverse())
							.enter().append("g")
							.attr("class", function (d) {
											legendClassArray.push(d.replace(/\s/g, ''));
											return "legend";
							})
							.attr("transform", function(d, i) { return "translate(0," + (i * 18 - 10) + ")"; });

		legendClassArray = legendClassArray.reverse();
		legend.append("rect")
							.attr("x", width)
							.attr("y", 18)
							.attr("width", 15)
							.attr("height", 15)
							.style("fill", color)
							.attr("id", function (d, i) {	return "id" + d.replace(/\s/g, '');  })

		legend.append("text")
							.attr("x", width - 10)
							.attr("y", 26)
							.attr("dy", ".35em")
							.style("text-anchor", "end")
							.style("font-size", textfontsize)
							.text(function(d) { return d ; });


		function restorePlot(d) {
			state.selectAll("rect").forEach(function (d, i) {
							d3.select(d[idx])
							.transition()
							.duration(1000)
							.attr("y", y_orig[i]);
			})

			for (var i = 0; i < legendClassArray.length; i++) {
				if (legendClassArray[i] != class_keep) {
					d3.selectAll(".class" + legendClassArray[i])
														.transition()
														.duration(1000)
														.delay(750)
														.style("opacity", 1);
				}
			}
		}

		function plotSingle(d) {
			class_keep = d.id.split("id").pop();
			idx = legendClassArray.indexOf(class_keep);

			for (var i = 0; i < legendClassArray.length; i++) {
				if (legendClassArray[i] != class_keep) {
					d3.selectAll(".class" + legendClassArray[i])
														.transition()
														.duration(1000)
														.style("opacity", 0);
				}
			}

			y_orig = [];
			state.selectAll("rect").forEach(function (d, i) {
										h_keep = d3.select(d[idx]).attr("height");
										y_keep = d3.select(d[idx]).attr("y");
										y_orig.push(y_keep);
										h_base = d3.select(d[0]).attr("height");
										y_base = d3.select(d[0]).attr("y");
										h_shift = h_keep - h_base;
										y_new = y_base - h_shift;

										d3.select(d[idx])
														.transition()
														.ease("bounce")
														.duration(1000)
														.delay(750)
														.attr("y", y_new);
		  })
		}
	}


	buildSecondBarChart(data){
  	var colorScheme = ["#2185D0","#db2e2e","#7986CB","#A1887F","#90A4AE","#AED581","#9575CD","#FF8A65","#4DB6AC","#FFF176","#64B5F6","#00E676"];

    var margin = {top: 0, right: 18, bottom: 10, left: 80},
				width = 630 - margin.left - margin.right,
				height = 260 - margin.top - margin.bottom,
				height2 = height*0.75;

		var column_width = 42;

		var textfontsize = "12px";

		var w = window.innerWidth;
		if (w < 767){
		  margin = {top: 0, right: 20, bottom: 10, left: 70};
		  width = window.innerWidth - margin.left - margin.right - 25;
		  height = 220 - margin.top - margin.bottom,
			height2 = height*0.75
		  column_width = 21;
		  textfontsize = "8px";
		}

		var x = d3.scale.ordinal().rangeRoundBands([0, width], .1);
		var y = d3.scale.linear().rangeRound([height2, 0]);
		var color = d3.scale.ordinal().range(colorScheme);
		var xAxis = d3.svg.axis().scale(x).orient("bottom")
							.tickFormat(function(d) {
								//return (new Date(+d) + "").substring(3,6);
								return d;
							});

		var yAxis = d3.svg.axis().scale(y).orient("left")
							.tickFormat(function(d) {
								return d + " Kw.h";
							});

    d3.selectAll("#chart2 > *").remove();

		var svg = d3.select("#chart2").append("svg")
		          .attr("id", "chartSVG2")
							.attr("width", width + margin.left + margin.right)
							.attr("height", height + margin.top + margin.bottom)
							//.attr("style","background:#efefef;")

		var main = svg.append("g")
							.attr("height", height2)
							.attr("transform", "translate(" + margin.left + "," + (height*0.20) + ")");

		var active_link = "0";
		var legendClicked;
		var legendClassArray = [];
		var y_orig;
		var class_keep;
		var idx;
		var h_keep, y_keep, h_base, y_base, h_shift, y_new;

		color.domain(d3.keys(data[0]).filter(function(key) { return key !== "label"; }));

		data.forEach(function(d) {
			var mylabel = d.label;
			var y0 = 0;
			d.params = color.domain().map(function(name) {
			          return {
			            mylabel:mylabel,
			            name: name,
			            y0: y0,
			            y1: y0 += +d[name],
			            show: d[name]
			          }; });
			d.total = d.params[d.params.length - 1].y1;
		});

		x.domain(data.map(function(d) { return (d.label); }));
		y.domain([0, d3.max(data, function(d) { return d.total; })]);

		main.append("g")
							.attr("class", "x axis")
							.attr("transform", "translate(0," + height2 + ")")
							.style("stroke-width","0px")
							.attr("stroke","#2185D0")
							.attr("style","color:#2185D0; font-weight:100;")
							.style("font-size", textfontsize)
							.call(xAxis);

		main.append("g")
							.attr("class", "y axis")
							.style("stroke-width","0.1px")
							.attr("stroke","#2185D0")
							.attr("fill","0px")
							.style("font-size", textfontsize)
							.call(yAxis)
							.append("text")
							.attr("style","color:#2185D0; font-weight:100;")
							.style("font-size", textfontsize)
							.attr("transform", "rotate(-90)")
							.attr("y", 6)
							.attr("dy", ".71em")
							.style("text-anchor", "end");

		var state = main.selectAll(".state")
							.data(data)
							.enter().append("g")
							.attr("class", "g")
							.attr("transform", function(d) { return "translate(" + "0" + ",0)"; });


		state.selectAll("rect")
							.data(function(d) {	return d.params; })
							.enter().append("rect")
							.attr("width", column_width)
							.attr("y", function(d) { return y(d.y1); })
							.attr("x",function(d) { return x(d.mylabel)  })
							.attr("height", function(d) { if (d.show > 0) return y(d.y0) - y(d.y1); else return 0; })
							.attr("class", function(d) {
											var classLabel = d.name.replace(/\s/g, '');
											return "class" + classLabel;
							})
							.style("fill", function(d) { return color(d.name); })


		state.append("text")
		          .attr("y", function(d) { return y(d.params[0].y1) + (column_width-4)/2; })
	            .attr("x", function(d) { return x(d.params[0].mylabel) + column_width/2; } )
              .style("text-anchor", "middle")
	            .style("font-size", textfontsize)
	            .style("stroke", "white")
	            .style("stroke-width","0")
	            .style("fill", "white");

		state.selectAll("rect")
							.on("mouseover", function(d){
											var delta = d.y1 - d.y0;
											var xPos = parseFloat(d3.select(this).attr("x"));
											var yPos = parseFloat(d3.select(this).attr("y"));
											var height = parseFloat(d3.select(this).attr("height"))
											d3.select(this).attr("stroke","blue").attr("stroke-width",0.8);
											//	tip.show(d);
											/*	main.append("text")
														.attr("x",xPos)
														.attr("y",yPos +height/2)
														.attr("class","tooltip")
														.text(d.name +": "+ delta.toFixed(0));
											*/
							})
							.on("mouseout",function(){
											//tip.hide();
											/*main.select(".tooltip").remove();*/
											d3.select(this).attr("stroke","pink").attr("stroke-width",0.2);
							})

		var legend = svg.selectAll(".legend")
							.data(color.domain().slice().reverse())
							.enter().append("g")
							.attr("class", function (d) {
											legendClassArray.push(d.replace(/\s/g, ''));
											return "legend";
							})
							.attr("transform", function(d, i) { return "translate(0," + (i * 18 - 10) + ")"; });

		legendClassArray = legendClassArray.reverse();
		legend.append("rect")
							.attr("x", width + 32)
							.attr("y", 18)
							.attr("width", 15)
							.attr("height", 15)
							.style("fill", color)
							.attr("id", function (d, i) {	return "id" + d.replace(/\s/g, '');  })

		legend.append("text")
							.attr("x", width + 18)
							.attr("y", 26)
							.attr("dy", ".35em")
							.style("text-anchor", "end")
							.style("font-size", textfontsize)
							.text(function(d) { return d ; });


		function restorePlot(d) {
			state.selectAll("rect").forEach(function (d, i) {
							d3.select(d[idx])
							.transition()
							.duration(1000)
							.attr("y", y_orig[i]);
			})

			for (var i = 0; i < legendClassArray.length; i++) {
				if (legendClassArray[i] != class_keep) {
					d3.selectAll(".class" + legendClassArray[i])
														.transition()
														.duration(1000)
														.delay(750)
														.style("opacity", 1);
				}
			}
		}

		function plotSingle(d) {
			class_keep = d.id.split("id").pop();
			idx = legendClassArray.indexOf(class_keep);

			for (var i = 0; i < legendClassArray.length; i++) {
				if (legendClassArray[i] != class_keep) {
					d3.selectAll(".class" + legendClassArray[i])
														.transition()
														.duration(1000)
														.style("opacity", 0);
				}
			}

			y_orig = [];
			state.selectAll("rect").forEach(function (d, i) {
										h_keep = d3.select(d[idx]).attr("height");
										y_keep = d3.select(d[idx]).attr("y");
										y_orig.push(y_keep);
										h_base = d3.select(d[0]).attr("height");
										y_base = d3.select(d[0]).attr("y");
										h_shift = h_keep - h_base;
										y_new = y_base - h_shift;

										d3.select(d[idx])
														.transition()
														.ease("bounce")
														.duration(1000)
														.delay(750)
														.attr("y", y_new);
		  })
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/offers/barchart.service.ts